document.addEventListener("DOMContentLoaded", () => {
  // Registrar ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);

  // --- Función para dividir texto en palabras ---
  function splitWords(selector) {
    document.querySelectorAll(selector).forEach(el => {
      const text = el.innerText.trim();
      if (!text) return;
      const words = text.split(/\s+/);
      el.innerHTML = words.map(word => `<span class="word">${word}</span>`).join(" ");
    });
  }

  // --- Aplicar Split a todos los h3 ---
  splitWords("h1");
  splitWords(".h3");

  gsap.utils.toArray("h1, .h3").forEach(title => {
    gsap.from(title.querySelectorAll(".word"), {
      scrollTrigger: {
        trigger: title,
        start: "top 90%",
        toggleActions: "play none none reverse",
        markers: false // cambia a true para depurar
      },
      y: 30,
      opacity: 0,
      duration: 0.6,
      stagger: 0.08,
      ease: "power3.out"
    });
  });

  ScrollTrigger.refresh();
});
  

document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const marquees = document.querySelectorAll(".hero__marquee .marquee-track");

  marquees.forEach(track => {
    const width = track.offsetWidth / 2; // porque duplicamos el contenido

    gsap.to(track, {
      x: -width,
      duration: 12, // ajusta velocidad
      ease: "linear",
      repeat: -1
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const content = document.querySelector('.marquee-content');

  gsap.to(content, {
    xPercent: -100,
    repeat: -1,
    duration: 50,
    ease: 'linear'
  });
});

gsap.registerPlugin(ScrollTrigger);

var img2 = gsap.timeline({
  scrollTrigger: {
    trigger: ".resource-list",     // el contenedor del bloque
    start: "top 80%",              // cuando el top del bloque llegue al 80% del viewport
    toggleActions: "play none none reverse", // cómo reacciona al entrar/salir
  }
});

img2.fromTo(".resource-list__item",
  { 'clip-path': 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)' },
  { 
    'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
    duration: 1.3,
    ease: 'power4.inOut',
    stagger: 0.1
  }
);

// selecciona todos los elementos con la clase .animar
const animarElements = document.querySelectorAll(".animar");

// recorre cada elemento y crea un ScrollTrigger individual
animarElements.forEach((el) => {
  gsap.fromTo(
    el,
    { 'clip-path': 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)', y: 50 },
    {
      'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
      y: 0,
      duration: 1,
      stagger: 0.2,
      ease: 'power4.inOut',
      scrollTrigger: {
        trigger: el,
        start: "top 85%", // cuando el top del elemento llegue al 80% del viewport
        toggleActions: "play none none reverse"
      }
    }
  );
});

document.addEventListener('DOMContentLoaded', function() {
  const content = document.querySelector('.video2');

  gsap.to(".marquee-video", {
    x: "-100%",
    ease: "linear",
    duration: 90,
    repeat: -1
  });
});

document.addEventListener("DOMContentLoaded", function () {
    gsap.registerPlugin(ScrollTrigger);

    const productos = document.querySelectorAll(".producto");

    productos.forEach((producto, i) => {
      gsap.fromTo(
        producto,
        {
          'clip-path': 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)', y: 50
        },
        {
          'clip-path': 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          y: 0,
          duration: 1,
          stagger: 0.2,
          ease: "power3.out",
          delay: i * 0.1,
          scrollTrigger: {
            trigger: producto,
            start: "top 85%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });
  });

